import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MbscDatepickerOptions, MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { PDxListItem } from 'src/app/core/PDxListItem.model';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import * as moment from 'moment';
import { PDxReportType } from 'src/app/core/PDxReportType.enum';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styles: [
  ]
})
export class AdminDashboardComponent implements OnInit {

  filters: EntityFilter[] = [];

  refToMoment = moment;
  dateOptions: MbscDatepickerOptions = {
    controls: ['calendar'],
    select: 'range',
    theme: 'ios',
    themeVariant: 'light',
    returnFormat: 'moment',
    dateFormat: 'M/D/YYYY',
    calendarType: 'month',
    onChange: () => {

    }
  };
  dateRangeFilter: moment.Moment[];

  pdxReportType = PDxReportType;

  constructor(private ajax: ajaxCall,
    private notifier: NotifierService) {

  }

  ngOnInit(): void {
    this.addEntity();
  }

  addEntity(): void {
    this.filters.push(new EntityFilter(this.ajax));
  }

  removeEntity(idx: number): void {
    this.filters.splice(idx, 1);
  }

  downloadReport(type: PDxReportType): void {
    var f = new FullReportFilter();
    f.type = type;
    if (this.dateRangeFilter) {
      if ((this.dateRangeFilter.length > 0) && (this.dateRangeFilter[0])) {
        f.startDate = this.dateRangeFilter[0].startOf('day').utc().valueOf();
      }
      if ((this.dateRangeFilter.length > 1) && (this.dateRangeFilter[1])) {
        f.endDate = this.dateRangeFilter[1].endOf('day').utc().valueOf();
      }
    }
    this.filters.forEach((x) => {
      if (x.accountId) {
        f.entities.push({ accountId: x.accountId, entityIds: x.entityIds });
      }
    });
    this.ajax.MakeCall('/Report/Start', f).then(() => {
      this.notifier.notify('success', 'Your request has been added to the queue and you will receive an email when it is complete');
    }, () => { });
  }
}

class FullReportFilter {
  constructor() {
    this.entities = [];
  }
  type: PDxReportType;
  startDate: number;
  endDate: number;
  entities: FullEntityFilter[];
}

class FullEntityFilter {
  accountId: string;
  entityIds: string[];
}

class EntityFilter {
  constructor(private ajax: ajaxCall) {

  }

  // actual values
  accountId: string;
  entityIds: string[];

  // helper values to make the filtering work
  filterCount: number = 0;
  accounts: PDxListItem<string>[] = [];
  selectOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            if (this.accounts.filter((x) => x.value == this.accountId).length == 0) {
              this.accountId = null;
            }
          }
        }, () => { });
      } else {
        if (this.accounts.filter((x) => x.value == this.accountId).length == 0) {
          this.accountId = null;
        }
      }
      return false;
    },
    onChange: (event, inst) => {

    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.accounts = [];
        this.entities = [];
      }
    }]
  };
  entities: PDxListItem<string>[] = [];
  parentOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    selectMultiple: true,
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.entities = [];
      if (!this.accountId) {
        return false;
      }
      if (ev.filterText) {
        this.parentOptions.filterEmptyText = 'No Results';
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: this.accountId, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.entities = data;
          }
        }, () => { });
      } else {
        this.parentOptions.filterEmptyText = 'Search Entities';
      }
      return false;
    },
    onChange: (ev: any) => {
    },
    filterEmptyText: 'Search Entities',
    buttons: [{
      text: 'clear', handler: (event) => {
        this.entities = [];
      }
    }]
  };
}